export const ingredients = [
  {
    slug: 'chamomile',
    name: 'Chamomile',
    origin: 'Egypt',
    short: 'Calm & sleep',
    benefit: 'Soothes the nervous system and prepares the body for deep, restful sleep.',
    detail: 'A tender daisy-like flower cherished since Ancient Egypt. Its warm apple-honey aroma quiets the mind and prepares the body for the natural descent into sleep.',
    teas: ['Bedtime Tea'],
    image: 'https://images.pexels.com/photos/13641676/pexels-photo-13641676.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'ashwagandha',
    name: 'Ashwagandha',
    origin: 'India',
    short: 'Adaptogen',
    benefit: 'An ancient adaptogen that balances stress and quietly rebuilds resilience.',
    detail: 'A revered Ayurvedic root known as the "strength of the stallion." Adaptogenic and gently grounding, it helps the body meet modern stress with old-world calm.',
    teas: ['Bedtime Tea', "Women's Care Tea"],
    image: 'https://images.pexels.com/photos/5103296/pexels-photo-5103296.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'brahmi',
    name: 'Brahmi',
    origin: 'India',
    short: 'Clarity',
    benefit: 'A traditional Ayurvedic herb that clears mental fog and lifts focus.',
    detail: 'A herb of scholars and yogis, Brahmi has been used for centuries to sharpen memory, ease anxiety and support a steady, clear mind.',
    teas: ['Bedtime Tea'],
    image: 'https://images.pexels.com/photos/12897177/pexels-photo-12897177.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'hibiscus',
    name: 'Hibiscus',
    origin: 'Sudan',
    short: 'Antioxidant',
    benefit: 'A deep-crimson flower rich in antioxidants for radiant, glowing skin.',
    detail: 'The garnet-red petals brew into a jewel-toned infusion, bright with vitamin C and antioxidants that support heart health and a lit-from-within glow.',
    teas: ['Detox Tea'],
    image: 'https://images.pexels.com/photos/15825873/pexels-photo-15825873.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'ginger',
    name: 'Ginger',
    origin: 'Southeast Asia',
    short: 'Digestive fire',
    benefit: 'Warms the digestive fire and eases nausea with its bright, peppery bite.',
    detail: 'A sunlit root with an unmistakable warmth. Traditionally used to stir sluggish digestion, soothe the belly and awaken circulation.',
    teas: ['Detox Tea'],
    image: 'https://images.pexels.com/photos/4871339/pexels-photo-4871339.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'raw-turmeric',
    name: 'Raw Turmeric',
    origin: 'India',
    short: 'Golden root',
    benefit: 'The golden root — nature\'s original anti-inflammatory ally.',
    detail: 'A saffron-hued rhizome carrying curcumin, prized in Ayurveda for centuries as a gentle daily anti-inflammatory and immune support.',
    teas: ['Detox Tea'],
    image: 'https://images.pexels.com/photos/6220709/pexels-photo-6220709.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'spearmint',
    name: 'Spearmint',
    origin: 'Mediterranean',
    short: 'Cool clarity',
    benefit: 'Cooling and bright — supports hormonal balance and clear skin.',
    detail: 'Softer and sweeter than peppermint, spearmint carries a green, cooling breath. Studies suggest it supports hormonal equilibrium and skin clarity.',
    teas: ["Women's Care Tea"],
    image: 'https://images.pexels.com/photos/8080428/pexels-photo-8080428.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'shatavri',
    name: 'Shatavri',
    origin: 'India',
    short: 'Feminine tonic',
    benefit: 'Ayurveda\'s "one who has a hundred husbands" — the feminine tonic.',
    detail: 'A cooling Ayurvedic root traditionally used to nourish the female reproductive system, support hormonal cycles and gentle vitality.',
    teas: ["Women's Care Tea"],
    image: 'https://images.pexels.com/photos/4136923/pexels-photo-4136923.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
  {
    slug: 'nettle',
    name: 'Nettle',
    origin: 'Europe',
    short: 'Mineral rich',
    benefit: 'A mineral-rich wild green that quietly nourishes hair, skin and blood.',
    detail: 'A wild green tonic dense with iron, magnesium and silica. Gently cleansing and deeply nourishing — the herbalist\'s multivitamin.',
    teas: ["Women's Care Tea"],
    image: 'https://images.pexels.com/photos/12726627/pexels-photo-12726627.jpeg?auto=compress&cs=tinysrgb&w=1200',
  },
];
